import React from 'react'
import { Link, useLocation } from 'react-router-dom'

import { useGlobalContext } from '../../../context/ContextGlobal'

export const NavbarLink = (
  { children, link = null, colorBackgroud = null, colorText = null, action = () => {} },
  inDropDrown = false,
) => {
  const { setNavBar } = useGlobalContext()

  const location = useLocation()

  const classe = `navbar-item navbar-item-hover-opacity ${colorBackgroud} ${colorText} ${location.pathname === link && !inDropDrown ? 'navbar-item.navbar-item-active' : ''}`

  return (
    <Link
      to={link}
      className={classe}
      onClick={() => {
        action()
        setNavBar(false)
      }}
    >
      <p className={`mx-2 ${colorText}`}>{children}</p>
    </Link>
  )
}
